import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  modal: {
    display: "flex",
    marginTop: 48,
    backgroundColor: "white",
    width: "300px",
    marginLeft: 75,
    zIndex: "1 !important"
  },
  paper: {
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    outline: "none",
    overflow: "auto",
    width: "100%"
  },
  title: {
    font: "var(--size-24px) / var(--size-48px) var(--font-family-diodrum_semi-bold)",
    color: "var(--color-primary)",
    letterSpacing: 0,
    marginBottom: 0
  },
  description: {
    font: "var(--size-12px) / var(--size-16px) var(--font-family-noto-sans)",
    color: "var(--color-medium-grey)",
    letterSpacing: "0px",
    margin: 0,
    paddingRight: "20px"
  },
  description_secondary: {
    font: "var(--size-9px) / var(--line-spacing-12) var(--font-family-diodrum)",
    color: "var(--color-medium-grey)",
    letterSpacing: "0px",
    display: "block",
    marginTop: "5px"
  },
  modalHeader: {
    padding: "20px 10px 0 20px"
  },
  modalBody: {
    marginTop: "15px",
    minHeight: "calc(100vh - 280px)",
    height: "calc(100vh - 280px)",
    overflow: "auto"
  },
  modalFooter: {
    display: "flex",
    width: "100%",
    position: "absolute",
    bottom: "0",
    justifyContent: "space-around",
    padding: "20px 20px 30px 20px",
    backgroundColor: "var(--color-white)"
  },
  backIcon: {
    marginTop: "5px",
    display: "inline-block",
    float: "left",
    cursor: "pointer",
    marginLeft: "-10px"
  },
  btnSpacing: {
    margin: "0 20px 0 0",
    flex: "1"
  }
}));
export { useStyles };
